import { useRecordModal } from 'hooks/useRecordModal';
import { MonitoringSettingsEditDialog } from 'pages/Monitoring/MonitoringSettings/MonitoringSettingsEditDialog/MonitoringSettingsEditDialog';
import { WithListContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { EditIconButton } from 'shared/mui/IconButtons';
import { FunctionField, NumberField, TextField } from 'shared/react-admin/Fields';
import { ListPage } from 'shared/react-admin/Pages';
import { MonitoringSetting } from 'types/embedded/monitoringSetting';

import { DatagridStyled } from './MonitoringSettingsList.styled';

export const MonitoringSettingsList: React.FC = () => {
  const {
    record: recordEditDialog,
    openRecordModal: openEditDialog,
    handleOpenRecordModal: handleOpenEditDialog,
    handleCloseRecordModal: handleCloseEditDialog,
  } = useRecordModal<MonitoringSetting>();

  return (
    <ListPage
      empty={false}
      headerTitle={{ titleText: 'Настройки мониторинга' }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <WithListContext
        render={({ data, isLoading }) => {
          if (!data?.length && !isLoading) {
            return <Alert severity="info">Нет результатов</Alert>;
          }

          return (
            <DatagridStyled bulkActionButtons={false}>
              <TextField label="ID" sortBy="id" source="originId" />
              <TextField label="Алиас" sortable={false} source="alias" />
              <NumberField label="Настройки" sortable={false} source="settings.alertMinCount" />
              <FunctionField
                label=""
                render={(record: MonitoringSetting) => (
                  <EditIconButton color="secondary" onClick={() => handleOpenEditDialog(record)} />
                )}
              />
            </DatagridStyled>
          );
        }}
      />
      <MonitoringSettingsEditDialog
        onClose={handleCloseEditDialog}
        open={openEditDialog}
        record={recordEditDialog}
      />
    </ListPage>
  );
};
